import { createUseNotifications } from '@gokrew/ui';
import {
  deleteNotification,
  getNotifications,
  getNotificationsUnreadCount,
  markAllNotificationsRead,
  markNotificationRead,
  openNotificationStream,
  runNotificationAction,
} from '@/api/notifications';
import { useEmployeePortalAuth } from '@/context/EmployeeAuthContext';

/**
 * The employee endpoints resolve the company from the token, so `companyId` is
 * only ever a cache scope here — it keeps a mock-login session from reading the
 * previous employee's feed, and nothing is threaded into a path.
 */
export const notificationHooks = createUseNotifications({
  useCompanyId: () => useEmployeePortalAuth().user?.company?.id,
  createApi: () => ({
    getFeed: getNotifications,
    getUnreadCount: getNotificationsUnreadCount,
    markRead: markNotificationRead,
    markAllRead: markAllNotificationsRead,
    remove: deleteNotification,
    runAction: runNotificationAction,
    openStream: openNotificationStream,
  }),
});

export const {
  useNotificationsUnreadCount,
  useNotificationFeed,
  useNotificationMutations,
  useNotificationStream,
  useRefreshNotifications,
} = notificationHooks;
